import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
  root: {
    width: window.innerWidth,
  },
});


export default function TimeSlider() {
  const [time1, setTime1] = useState('');
  const [time2, setTime2] = useState('');

  const classes = useStyles();
  const [value, setValue] = React.useState([20, 137]);

  const valuetext = () => {
    let left = Math.floor(value[0] / 12);
    let float = value[0] / 12 - left;
    let right = float * 60;
    setTime1(`${left}:${Math.round(right)}`);

    left = Math.floor(value[1] / 12);
    float = value[1] / 12 - left;
    right = float * 60;
    setTime2(`${left}:${Math.round(right)}`);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Typography>{time1}</Typography>
      <Typography>{time2}</Typography>
      <Slider
        value={value}
        onChange={handleChange}
        aria-labelledby="range-slider"
        getAriaValueText={valuetext}
        step={1}
        min={0}
        max={12 * 24 - 1}
      />
      {/* <Slider
        defaultValue={0}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider"
        step={1}
        min={0}
        max={12 * 24 - 1}
      /> */}
    </div>
  );
}